import React from 'react';
import { useTranslation } from 'react-i18next';

const DonationSummary = ({ activeTab, currentAmount, autoAjrAmount, totalAmount }) => {
  const { t } = useTranslation();

  const containerStyle = {
    backgroundColor: '#f9fafb',
    padding: '1rem',
    borderRadius: '0.5rem',
    marginBottom: '1.5rem',
    color: 'var(--primary-color)'
  };

  const titleStyle = {
    fontSize: '1.125rem',
    fontWeight: '600',
    marginBottom: '0.5rem'
  };

  const lineItemStyle = {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #d1d5db',
    display: 'flex',
    justifyContent: 'space-between'
  };

  const totalRowStyle = {
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: '700'
  };

return (
    <div style={containerStyle}>
        <h3 style={titleStyle}>
            {t(activeTab === 'once' ? 'autoAjr.yourDonation' : 'autoAjr.yourWeeklyDonation')}
        </h3>
        <div style={lineItemStyle}>
            <span>{t(activeTab === 'once' ? 'autoAjr.donationAmount' : 'autoAjr.weeklyDonation')}</span>
            <span>£{currentAmount}</span>
        </div>
        <div style={lineItemStyle}>
            <span>{t('autoAjr.autoAjrSupport')}</span>
            <span>£{autoAjrAmount}</span>
        </div>
        <div style={totalRowStyle}>
            <span>
                {t(activeTab === 'once' ? 'autoAjr.total' : 'autoAjr.recurringJummahDonation')}
            </span>
            <span>£{totalAmount}</span>
        </div>
    </div>
);
};

export default DonationSummary;